import { TableSort } from '../models/table-sort.model';
import { PagingSize } from './paging-size.model';

/**
 * Payload when the table is sorted or paged
 */
export class DrawTableModel {
  pagingSize: PagingSize;
  tableSort: TableSort;
}
